export const themes = {
  dark: 'dark',
  light: 'light',
} as const;

export type Themes = keyof typeof themes;
